import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Ic, ICONS } from '../../data/icons';
import { Avatar } from '../shared';
import { DEVICES, USERS } from '../../data/mockData';

const NOTIFICATIONS = [
  { id:1, msg:"Surface Pro güvenlik ihlali",   detail:"murat.demir · 2 saat önce",   type:"error",   read:false, link:"/devices/3" },
  { id:2, msg:"12 cihazda bekleyen güncelleme", detail:"system · 3 saat önce",        type:"warning", read:false, link:"/devices" },
  { id:3, msg:"iPhone 15 Pro kaydedildi",       detail:"zeynep.arslan · 5 saat önce", type:"success", read:true,  link:"/devices/2" },
  { id:4, msg:"macOS 14.3 dağıtımı tamamlandı", detail:"system · 1 gün önce",         type:"info",    read:true,  link:"/reports" },
  { id:5, msg:"Yeni politika aktifleştirildi",  detail:"admin · 2 gün önce",          type:"info",    read:true,  link:"/policies" },
];

const N_COLORS = { error:"#ef4444", warning:"#f59e0b", success:"#22c55e", info:"#3b82f6" };
const N_ICONS  = { error:ICONS.alert, warning:ICONS.alert, success:ICONS.check, info:ICONS.info };

export default function Topbar({ theme, setTheme, onMenuClick, isMobile, time, C, currentUser }) {
  const navigate = useNavigate();
  const [searchVal, setSearchVal]       = useState("");
  const [searchOpen, setSearchOpen]     = useState(false);
  const [notifOpen, setNotifOpen]       = useState(false);
  const [userOpen, setUserOpen]         = useState(false);
  const [notifications, setNotifications] = useState(NOTIFICATIONS);
  const searchRef = useRef(null);
  const notifRef  = useRef(null);
  const userRef   = useRef(null);

  const unread = notifications.filter(n => !n.read).length;

  // Dışarı tıklanda kapat
  useEffect(() => {
    const handler = e => {
      if (notifRef.current && !notifRef.current.contains(e.target)) setNotifOpen(false);
      if (userRef.current && !userRef.current.contains(e.target)) setUserOpen(false);
      if (searchRef.current && !searchRef.current.contains(e.target)) setSearchOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // Arama sonuçları
  const q = searchVal.toLowerCase().trim();
  const searchResults = q.length > 1 ? [
    ...DEVICES.filter(d => d.name.toLowerCase().includes(q) || d.user.toLowerCase().includes(q) || d.serial.toLowerCase().includes(q)).slice(0, 4)
      .map(d => ({ id:`d${d.id}`, label:d.name, sub:`${d.user} · ${d.dept}`, icon:"devices", link:`/devices/${d.id}` })),
    ...USERS.filter(u => u.name.toLowerCase().includes(q) || u.email.toLowerCase().includes(q)).slice(0, 3)
      .map(u => ({ id:`u${u.id}`, label:u.name, sub:u.email, icon:"users", link:`/users` })),
  ] : [];

  const markAllRead = () => setNotifications(ns => ns.map(n => ({ ...n, read: true })));

  return (
    <div style={{ height:60, background:C.sidebar, borderBottom:`1px solid ${C.border}`, display:"flex", alignItems:"center", padding:"0 18px", gap:12, flexShrink:0, position:"relative", zIndex:30 }}>
      {isMobile && (
        <button onClick={onMenuClick} style={{ background:"none", border:"none", cursor:"pointer", color:C.textSub, display:"flex", padding:4, flexShrink:0 }}>
          <Ic d={ICONS.menu} size={20} />
        </button>
      )}

      {/* Search */}
      <div ref={searchRef} style={{ flex:1, maxWidth:isMobile?"100%":440, position:"relative" }}>
        <div style={{ display:"flex", alignItems:"center", gap:8, background:theme==="dark"?"rgba(255,255,255,0.05)":"rgba(0,0,0,0.05)", border:`1px solid ${searchOpen ? C.accentBorder : C.border}`, borderRadius:10, padding:"0 14px", height:38, transition:"border-color 0.15s" }}>
          <Ic d={ICONS.search} size={15} s={C.textFaint} />
          <input
            value={searchVal}
            onChange={e => { setSearchVal(e.target.value); setSearchOpen(true); }}
            onFocus={() => setSearchOpen(true)}
            placeholder="Cihaz, kullanıcı veya politika ara..."
            style={{ background:"none", border:"none", outline:"none", color:C.text, fontSize:13, width:"100%", fontFamily:"inherit" }}
          />
          {searchVal && <button onClick={() => { setSearchVal(""); setSearchOpen(false); }} style={{ background:"none", border:"none", cursor:"pointer", color:C.textFaint, display:"flex", padding:0 }}><Ic d={ICONS.x} size={13} /></button>}
          {!isMobile && !searchVal && <kbd style={{ fontSize:11, color:C.textFaint, background:C.border2, padding:"1px 6px", borderRadius:5 }}>⌘K</kbd>}
        </div>

        {/* Search dropdown */}
        {searchOpen && searchResults.length > 0 && (
          <div style={{ position:"absolute", top:"calc(100% + 6px)", left:0, right:0, background:C.surface, border:`1px solid ${C.border}`, borderRadius:12, boxShadow:C.shadow, overflow:"hidden", zIndex:100 }}>
            {searchResults.map(r => (
              <div key={r.id} onClick={() => { navigate(r.link); setSearchOpen(false); setSearchVal(""); }}
                style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 14px", cursor:"pointer", transition:"background 0.1s" }}
                onMouseEnter={e => e.currentTarget.style.background = C.surface2}
                onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                <div style={{ width:28, height:28, borderRadius:8, background:C.accentBg, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                  <Ic d={ICONS[r.icon]} size={13} s={C.accent} />
                </div>
                <div style={{ minWidth:0 }}>
                  <div style={{ fontSize:13, fontWeight:600, color:C.text, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{r.label}</div>
                  <div style={{ fontSize:11, color:C.textFaint }}>{r.sub}</div>
                </div>
              </div>
            ))}
          </div>
        )}
        {searchOpen && q.length > 1 && searchResults.length === 0 && (
          <div style={{ position:"absolute", top:"calc(100% + 6px)", left:0, right:0, background:C.surface, border:`1px solid ${C.border}`, borderRadius:12, boxShadow:C.shadow, padding:"16px 14px", textAlign:"center", fontSize:12, color:C.textFaint, zIndex:100 }}>
            "{searchVal}" için sonuç bulunamadı
          </div>
        )}
      </div>

      <div style={{ marginLeft:"auto", display:"flex", alignItems:"center", gap:isMobile?10:14, flexShrink:0 }}>
        {!isMobile && <div style={{ fontSize:12, color:C.textFaint, fontVariantNumeric:"tabular-nums" }}>{time.toLocaleTimeString("tr-TR")}</div>}

        {/* Theme */}
        <button onClick={() => setTheme(t => t==="dark"?"light":"dark")} style={{ width:36, height:36, borderRadius:9, border:`1px solid ${C.border}`, background:"none", cursor:"pointer", color:C.textSub, display:"flex", alignItems:"center", justifyContent:"center" }}>
          <Ic d={theme==="dark"?ICONS.sun:ICONS.moon} size={16} />
        </button>

        {/* Notifications */}
        <div ref={notifRef} style={{ position:"relative" }}>
          <button onClick={() => { setNotifOpen(o => !o); setUserOpen(false); }} style={{ width:36, height:36, borderRadius:9, border:`1px solid ${notifOpen ? C.accentBorder : C.border}`, background:notifOpen ? C.accentBg : "none", cursor:"pointer", color:C.textSub, display:"flex", alignItems:"center", justifyContent:"center", position:"relative" }}>
            <Ic d={ICONS.bell} size={17} />
            {unread > 0 && <span style={{ position:"absolute", top:6, right:6, width:8, height:8, background:"#ef4444", borderRadius:"50%", border:`2px solid ${C.sidebar}` }} />}
          </button>

          {notifOpen && (
            <div style={{ position:"absolute", top:"calc(100% + 8px)", right:0, width:340, background:C.surface, border:`1px solid ${C.border}`, borderRadius:14, boxShadow:C.shadow, overflow:"hidden", zIndex:100 }}>
              <div style={{ padding:"13px 16px", borderBottom:`1px solid ${C.border}`, display:"flex", alignItems:"center", justifyContent:"space-between" }}>
                <div style={{ fontWeight:700, color:C.text, fontSize:13.5 }}>Bildirimler {unread > 0 && <span style={{ fontSize:10, background:C.redBg, color:C.red, padding:"1px 6px", borderRadius:99, marginLeft:6 }}>{unread} yeni</span>}</div>
                {unread > 0 && <button onClick={markAllRead} style={{ fontSize:11, color:C.accent, background:"none", border:"none", cursor:"pointer", fontWeight:600 }}>Tümünü oku</button>}
              </div>
              {notifications.map((n, i) => {
                const col = N_COLORS[n.type];
                return (
                  <div key={n.id} onClick={() => { navigate(n.link); setNotifOpen(false); setNotifications(ns => ns.map(x => x.id===n.id ? {...x,read:true} : x)); }}
                    style={{ display:"flex", alignItems:"flex-start", gap:10, padding:"11px 16px", cursor:"pointer", opacity:n.read?0.6:1, borderBottom:i<notifications.length-1?`1px solid ${C.border}`:"none", background:"transparent", transition:"background 0.1s" }}
                    onMouseEnter={e => e.currentTarget.style.background = C.surface2}
                    onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                    {!n.read && <span style={{ width:6, height:6, borderRadius:"50%", background:col, flexShrink:0, marginTop:5 }} />}
                    {n.read && <span style={{ width:6, height:6, flexShrink:0 }} />}
                    <div style={{ width:28, height:28, borderRadius:8, background:`${col}20`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                      <Ic d={N_ICONS[n.type]} size={13} s={col} />
                    </div>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ fontSize:12.5, color:C.text, fontWeight:n.read?400:600, marginBottom:2, lineHeight:1.4 }}>{n.msg}</div>
                      <div style={{ fontSize:11, color:C.textFaint }}>{n.detail}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* User menu */}
        <div ref={userRef} style={{ position:"relative" }}>
          <button onClick={() => { setUserOpen(o => !o); setNotifOpen(false); }} style={{ display:"flex", alignItems:"center", gap:8, background:"none", border:`1px solid ${userOpen ? C.accentBorder : C.border}`, borderRadius:9, padding:"3px 10px 3px 4px", cursor:"pointer" }}>
            <Avatar initials={(currentUser?.name || "AK").split(" ").map(s=>s[0]).join("").slice(0,2).toUpperCase()} size={28} />
            {!isMobile && <span style={{ fontSize:12.5, color:C.text, fontWeight:600 }}>{currentUser?.name?.split(" ")[0] || "Admin"}</span>}
            <Ic d={ICONS.chevD} size={12} s={C.textFaint} />
          </button>

          {userOpen && (
            <div style={{ position:"absolute", top:"calc(100% + 8px)", right:0, width:220, background:C.surface, border:`1px solid ${C.border}`, borderRadius:12, boxShadow:C.shadow, overflow:"hidden", zIndex:100 }}>
              <div style={{ padding:"14px 16px", borderBottom:`1px solid ${C.border}` }}>
                <div style={{ fontSize:13.5, fontWeight:700, color:C.text }}>{currentUser?.name || "Admin Kullanıcı"}</div>
                <div style={{ fontSize:11.5, color:C.textFaint }}>{currentUser?.email || "admin@corpmdm.com"}</div>
                <div style={{ marginTop:6 }}><span style={{ fontSize:10, fontWeight:700, padding:"2px 8px", borderRadius:99, background:C.accentBg, color:C.accent }}>{currentUser?.role || "Süper Admin"}</span></div>
              </div>
              {[
                { icon:"settings", label:"Ayarlar", action: () => navigate("/settings") },
                { icon:"key",      label:"Şifre Değiştir", action: () => navigate("/settings") },
              ].map(item => (
                <div key={item.label} onClick={() => { item.action(); setUserOpen(false); }}
                  style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 16px", cursor:"pointer", fontSize:13, color:C.textSub, transition:"background 0.1s" }}
                  onMouseEnter={e => e.currentTarget.style.background = C.surface2}
                  onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                  <Ic d={ICONS[item.icon]} size={14} />
                  {item.label}
                </div>
              ))}
              <div style={{ borderTop:`1px solid ${C.border}` }}>
                <div onClick={() => { localStorage.removeItem("mdm_token"); window.location.href = "/login"; }}
                  style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 16px", cursor:"pointer", fontSize:13, color:C.red, transition:"background 0.1s" }}
                  onMouseEnter={e => e.currentTarget.style.background = C.redBg}
                  onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                  <Ic d={ICONS.logOut} size={14} />
                  Çıkış Yap
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
